import React from "react";
import "./Header.scss";
import { motion } from "framer-motion";

import { AppWrap } from "../../wrapper";

import { images } from "../../constants";
import Lottie from "react-lottie";
import { setLottieOptions } from "../../constants/lottieOptions";
import programing from "../../assets/lottie/programing.json";
import { links } from '../../constants/links';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => {
  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex ">
            <>👋</>
            <div style={{ marginLeft: 10 }}>
              <h1>OBEN TABIAYUK</h1>
            </div>
          </div>
          <div className="tag-cmp app__flex">
            <p className="p-text">Sr. Software Engineer</p>
            <p className="p-text">Game Engineer</p>
          </div>
        </div>
      </motion.div>
      <a
        href={links.RESUME}
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="download_button">Download Resume</button>
      </a>
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        <Lottie
          options={setLottieOptions(programing)}
          width={750}
          height={750}
        />
      </motion.div>
      <motion.div
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {[
          images.react,
          images.javascript,
          images.react_native,
          images.css,
          images.typescript,
        ].map((circle, index) => (
          <div className="circle-cmp app__flex" key={`circle--${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, "home");
